module.exports = __webpack_public_path__ + "02961038ac55c9b250442701afc59ae0.jpg";